import { Container } from "react-bootstrap";

const PolitiqueConfidentialite = () => {
  return (
    <Container className="my-5">
      <h1 className="mb-4">Politique de confidentialité</h1>

      <p>
        La présente politique de confidentialité a pour but d’informer les utilisateurs du site <strong>Renovestim</strong> des données collectées, de leur traitement, de leur conservation et des droits qui leur sont conférés en vertu du <strong>Règlement Général sur la Protection des Données (RGPD)</strong>.
      </p>

      <h4>1. Responsable du traitement</h4>
      <p>
        <strong>Renovestim</strong><br />
        79256301700021<br />
        Email : <a href="mailto:contact@renovestim.com">contact@renovestim.com</a>
      </p>

      <h4>2. Données collectées</h4>
      <p>Nous collectons les données suivantes :</p>
      <ul>
        <li>Nom et prénom</li>
        <li>Adresse email</li>
        <li>Informations de connexion (email, mot de passe chiffré)</li>
        <li>Données relatives à vos projets de rénovation</li>
        <li>Données de paiement (gérées via Stripe)</li>
        <li>Adresse IP, données de navigation (via cookies)</li>
      </ul>

      <h4>3. Finalités du traitement</h4>
      <p>Les données sont collectées pour les finalités suivantes :</p>
      <ul>
        <li>Création et gestion du compte utilisateur</li>
        <li>Suivi et estimation de projets</li>
        <li>Facturation, paiements et abonnements</li>
        <li>Amélioration de l'expérience utilisateur</li>
        <li>Statistiques d'utilisation du site</li>
        <li>Envoi d’emails transactionnels et d’informations</li>
      </ul>

      <h4>4. Base légale du traitement</h4>
      <p>
        Le traitement des données repose sur le consentement, l’exécution d’un contrat, le respect d’obligations légales ou l’intérêt légitime de Renovestim.
      </p>

      <h4>5. Durée de conservation</h4>
      <p>
        Les données sont conservées pendant toute la durée de la relation contractuelle, et jusqu’à 3 ans après la dernière interaction à des fins de prospection, sauf obligations légales contraires.
      </p>

      <h4>6. Destinataires des données</h4>
      <p>
        Les données collectées sont exclusivement accessibles par :
      </p>
      <ul>
        <li>L’équipe interne de Renovestim</li>
        <li>Les prestataires techniques (ex : hébergement, paiement Stripe)</li>
      </ul>
      <p>Aucune donnée n’est vendue ou cédée à des tiers non autorisés.</p>

      <h4>7. Vos droits</h4>
      <p>Conformément au RGPD, vous disposez des droits suivants :</p>
      <ul>
        <li>Droit d’accès</li>
        <li>Droit de rectification</li>
        <li>Droit à l’effacement</li>
        <li>Droit à la limitation du traitement</li>
        <li>Droit d’opposition</li>
        <li>Droit à la portabilité des données</li>
      </ul>
      <p>
        Pour exercer vos droits, contactez-nous à : <strong>contact@renovestim.com</strong>
      </p>

      <h4>8. Sécurité</h4>
      <p>
        Nous mettons en œuvre toutes les mesures techniques et organisationnelles appropriées pour garantir la sécurité et la confidentialité des données personnelles.
      </p>

      <h4>9. Transfert hors UE</h4>
      <p>
        Si vos données sont amenées à être transférées en dehors de l’Union européenne, cela se fera dans le respect du RGPD, avec des garanties appropriées.
      </p>

      <h4>10. Réclamation</h4>
      <p>
        Vous pouvez introduire une réclamation auprès de la CNIL : <a href="https://www.cnil.fr">www.cnil.fr</a>
      </p>

      <h4>Dernière mise à jour</h4>
      <p>{new Date().toLocaleDateString("fr-FR")}</p>
    </Container>
  );
};

export default PolitiqueConfidentialite;
